import { Phone, Star } from "lucide-react";
import { PRACTICE } from "@/data/practice";

export const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 bg-[#FAF9F6]/80 backdrop-blur-xl border-b border-[#E0E0D8]/60"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between gap-4">
        <a
          href="#accueil"
          data-testid="header-logo"
          className="flex items-center gap-2.5 group min-w-0"
        >
          <span className="flex-shrink-0 grid place-items-center w-9 h-9 rounded-xl bg-[#3F9E8E] text-white font-display text-lg font-bold">
            +
          </span>
          <span className="flex flex-col leading-tight min-w-0">
            <span className="font-display font-bold text-[#2C362B] text-sm sm:text-base truncate">
              Cabinet Infirmier
            </span>
            <span className="text-[10px] sm:text-xs text-[#7C877C] tracking-wide truncate">
              Victoire · Capucins · Bordeaux
            </span>
          </span>
        </a>

        <div className="flex items-center gap-3">
          <span className="hidden md:inline-flex items-center gap-1.5 text-sm font-medium text-[#2C362B]">
            <Star className="w-4 h-4 fill-[#E8B04B] text-[#E8B04B]" strokeWidth={1.5} />
            {PRACTICE.rating} · Google
          </span>
          <a
            href={`tel:${PRACTICE.phoneRaw}`}
            data-testid="header-call-button"
            className="inline-flex items-center gap-2 rounded-full bg-[#3F9E8E] text-white font-medium text-sm px-4 sm:px-5 py-2.5 shadow-md hover:bg-[#348275] hover:-translate-y-0.5 transition-[transform,background-color] duration-200"
            aria-label={`Appeler le ${PRACTICE.phone}`}
          >
            <Phone className="w-4 h-4" strokeWidth={2} />
            <span className="hidden sm:inline">{PRACTICE.phone}</span>
            <span className="sm:hidden">Appeler</span>
          </a>
        </div>
      </div>
    </header>
  );
};
